import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { getReferenceVideoAsset } from 'selectors'
import AssetShape from './AssetShape'
import * as Actions from '~/actions'
import { createText } from '~/features/konva-shapes/createText'
import { useAction } from '~/hooks'

const TextAssetOverlay = React.memo(({
  asset,
  index,
  scale,
  boundingRect,
  extSourcePos,
  extSourceSize,
  extSourceRotation,
  onChange,
  isTransform,
  setKonvaRefElems,
}) => {
  const [ node, setNode ] = useState()
  const updateAsset = useAction(Actions.layer.updateAssetInPreview, asset.id)
  const { width: referenceWidth } = useSelector(getReferenceVideoAsset)

  useEffect(() => {
    if (asset) {
      if (boundingRect.width > 0 && boundingRect.height > 0) {
        const data = createText(asset, { boundingRect, scale, isTransform })
        if (!asset.isInitialized) {
          const text = Array.from(data.children).find(node => node.className === 'Text'
                  && node.attrs.key === 'text')
          if (text) {
            updateAsset({
              isInitialized: true,
              settings: {
                size: {
                  width: Math.max(text.getWidth(), referenceWidth * 0.9),
                  height: text.getHeight(),
                },
              },
            })
          }
        }
        setNode(data)
      } else {
        setNode(undefined)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ asset, boundingRect, isTransform ])

  const { source, size } = useMemo(() => {
    const isText = node?.getWidth() > 0 && node?.getHeight() > 0
    const size = isText ? node.size() : {}
    const source = isTransform ? node : node?.toCanvas()
    return { source: isText ? source : null, size }
  }, [ isTransform, node ])

  return (
    <If condition={source && size.width >= 1 && size.height >= 1}>
      <AssetShape
        asset={asset}
        index={index}
        size={size}
        scale={scale}
        source={source}
        settings={asset.settings}
        boundingRect={boundingRect}
        extSourcePos={extSourcePos}
        extSourceSize={extSourceSize}
        extSourceRotation={extSourceRotation}
        onChange={onChange}
        isTransform={isTransform}
        setKonvaRefElems={setKonvaRefElems}
      />
    </If>
  )
})

export default TextAssetOverlay
